import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, keywords, image, type = "website" }) => {
  const location = useLocation();

  useEffect(() => {
    // 1. Update Title
    const siteTitle = title 
      ? `${title} | Jaina Enterprises` 
      : "Jaina Enterprises - Trusted Scrap Metal Supply & Recycling";
    document.title = siteTitle;

    // 2. Update Meta Description
    const defaultDesc = "Jaina Enterprises is a trusted name in the metal supply and scrap recycling industry. Committed to transparent transactions, complete GST compliance, and best scrap rates.";
    const metaDescValue = description || defaultDesc;
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', metaDescValue);

    // 3. Update Meta Keywords
    const defaultKeywords = "scrap metal, Jaina Enterprises, metal supply, scrap recycling, industrial scrap, GST compliant scrap, iron scrap, copper scrap, aluminium scrap, car scrap, plastic scrap, scrap rate, Delhi NCR scrap";
    const keywordsValue = keywords || defaultKeywords;
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywordsValue);

    // 4. Update Canonical URL
    const currentUrl = window.location.origin + location.pathname;
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', currentUrl);

    // 5. Ensure llms.txt link exists in head
    let llmsLink = document.querySelector('link[rel="llms"]');
    if (!llmsLink) {
      llmsLink = document.createElement('link');
      llmsLink.setAttribute('rel', 'llms');
      llmsLink.setAttribute('href', '/llms.txt');
      document.head.appendChild(llmsLink);
    }

    // 6. Update Open Graph & Twitter Tags
    const ogImageValue = image || (window.location.origin + "/logo1.jpeg");

    const ogTags = {
      "og:title": siteTitle,
      "og:description": metaDescValue,
      "og:image": ogImageValue,
      "og:url": currentUrl,
      "og:type": type,
      "og:site_name": "Jaina Enterprises",
      "twitter:card": "summary_large_image",
      "twitter:title": siteTitle,
      "twitter:description": metaDescValue,
      "twitter:image": ogImageValue
    };

    Object.entries(ogTags).forEach(([key, val]) => {
      const attributeName = key.startsWith("og:") ? "property" : "name";
      let tag = document.querySelector(`meta[${attributeName}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attributeName, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', val);
    });

  }, [title, description, keywords, image, type, location]);

  return null;
};

export default SEO;